import Api from '.';
import { endpoints } from './endpoints';
export default class quickbuyApi extends Api {

    FolioListKarvy(data) {
        let url = this.buildUrl(endpoints.quickbuy.FolioListKarvy)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GetRegisteredBanks(data) {
        let url = this.buildUrl(endpoints.quickbuy.GetRegisteredBanks)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    OrderGeneration(data) {
        let url = this.buildUrl(endpoints.quickbuy.OrderGeneration)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    PaymentRequest(data) {
        let url = this.buildUrl(endpoints.quickbuy.PaymentRequest)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GetPGResponse(data) {
        let url = this.buildUrl(endpoints.quickbuy.GetPGResponse)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    validateBrokerCode(data) {
        let url = this.buildUrl(endpoints.quickbuy.validateBrokerCode)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    folioBrokerList(data) {
        let url = this.buildUrl(endpoints.quickbuy.folioBrokerList)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
        // if (data && data.folioNo) {
        //     url = `${url}?folioNo=${data.folioNo}&planType=${data.planType}`
        // }
        // return this.fetch(url, "GET", null, data).then(response => response)
    }

    razorpayOrderGeneration(data) {
        let url = this.buildUrl(endpoints.quickbuy.razorpayOrderGeneration)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    razorpaySaveOrder(data) {
        let url = this.buildUrl(endpoints.quickbuy.razorpaySaveOrder)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetPGConfirmationdata(data) {
        let url = this.buildUrl(endpoints.quickbuy.GetPGConfirmationdata)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    

    RetryPaymentWB(data) {
        let url = this.buildUrl(endpoints.quickbuy.RetryPaymentWB)
        return this.fetch(url, "POST", JSON.stringify(data), {"appId": "EF5A45FBMB48BA40CCMBAC1CB319EFD60F7B"}).then(response => response)
    }
    GetPGResponseWB(data) {
        let url = this.buildUrl(endpoints.quickbuy.GetPGResponseWB)
        return this.fetch(url, "POST", JSON.stringify(data), {"appId": "EF5A45FBMB48BA40CCMBAC1CB319EFD60F7B"}).then(response => response)
    }
    GetPGConfirmationdataWB(data) {
        let url = this.buildUrl(endpoints.quickbuy.GetPGConfirmationdataWB)
        return this.fetch(url, "POST", JSON.stringify(data), {"appId": "EF5A45FBMB48BA40CCMBAC1CB319EFD60F7B"}).then(response => response)
    }

    // Journey tracking methods
    SaveBasicDetailsScreenOne(data) {
        let url = this.buildUrl(endpoints.quickbuy.SaveBasicDetailsScreenOne)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    SaveBoosterDetailsScreenTwo(data) {
        let url = this.buildUrl(endpoints.quickbuy.SaveBoosterDetailsScreenTwo)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    SaveBankDetailsScreenThree(data) {
        let url = this.buildUrl(endpoints.quickbuy.SaveBankDetailsScreenThree)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

}